import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import Seo from '../../utils/seo';

const NotFoundPage: React.FC = (): ReactElement => (
  <>
    <Seo
      pageTitle="Page Not Found | Oluwasegun Adepoju"
      description="The page you requested could not be found. Explore the homepage or get in touch."
      path="/404"
    />
    <section className="page_view nfp_page">
      <div className="nfp_inner">
        <p className="nfp_code">404</p>
        <h1 className="nfp_title">You&apos;ve wandered off the map.</h1>
        <p className="nfp_subtitle">
          This page doesn&apos;t exist — but there&apos;s plenty worth finding.
        </p>
        <nav className="nfp_links" aria-label="Recovery navigation">
          <Link className="nfp_link nfp_link--primary" to="/">
            ← Back home
          </Link>
          <Link className="nfp_link" to="/work">
            Browse Explorations
          </Link>
          <Link className="nfp_link" to="/contact">
            Get in touch
          </Link>
        </nav>
      </div>
    </section>
  </>
);

export default NotFoundPage;
